import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { AttachmentPreview } from './attachment-preview';

export const ImageAttachmentPreview = ({ attachment = {}, removeAttachments, handleRetry }) => {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    const { localMetadata, image_url } = attachment;
    const { uploadState } = localMetadata;
    // Keep local blob url to display an image
    if ('finished' !== uploadState && 'failed' !== uploadState) {
      setImageUrl(image_url);
    }
  }, [attachment]);

  const { localMetadata } = attachment;
  const { uploadState, id } = localMetadata;

  const remove = useCallback(() => {
    removeAttachments([id]);
  }, [id, removeAttachments]);

  const retry = useCallback(() => {
    handleRetry(attachment);
  }, [id, handleRetry]);

  return (
    <AttachmentPreview
      state={uploadState}
      remove={remove}
      retry={retry}
      imageSrc={imageUrl}
    />
  );
};

ImageAttachmentPreview.propTypes = {
  attachment: PropTypes.object,
  removeAttachments: PropTypes.func,
  handleRetry: PropTypes.func
};
